import React, { createContext, useCallback, useEffect, useState } from 'react'
import FetchLaserProfile from '../components/MyLaserProfileFetch';
import Cookies from 'js-cookie'

const EnvironmentContext = createContext()

const EnvironmentProvider = ({ isLocal, children }) => {
    const [selectedStandard, setSelectedStandard] = useState('iec')
    const [email, setEmail] = useState();
    const [otp, setOTP] = useState();
    const [myUser, setMyUser] = useState({})
    const { laserProfileIsFetching, myLaserProfile } = FetchLaserProfile(selectedStandard, isLocal)
    const [locationData, setLocationData] = useState(null)
    
    // useEffect(() => {
        //     console.log(`myUser was changed.`, myUser)
        // }, [myUser])
        
        useEffect(() => {
        const ipInfoToken = process.env?.['REACT_APP_IP_INFO']
        fetch(`https://ipinfo.io/json?token=${ipInfoToken}`)
            .then(res => {
                if (!res.ok) throw new Error('Network response was not ok');
                return res.json();
            })
            .catch(() => ({ country: "GB", timezone: "Europe" }))
            .then(data => {
                setLocationData(data);
            })
            .catch(err => {
                console.error("IPINFO FETCH ERROR:", err);
            });
    }, []);

    const log = (...args) => {
        if (isLocal) {
            console.log(...args)
        }
    }

    const handleLogout = () => {
        setMyUser(null)
    }


    return (
        <EnvironmentContext.Provider
            value={{ locationData, isLocal, otp, setOTP, setEmail, email, setMyUser, myUser, myLaserProfile, laserProfileIsFetching, handleLogout, log, selectedStandard, setSelectedStandard }}
        >
            {children}
        </EnvironmentContext.Provider>
    )
}

export { EnvironmentContext, EnvironmentProvider }